import { styled } from '@mui/material/styles';
import { Box, Tab } from '@mui/material';
import colors from 'styles/colors';

const CustomTab = styled(Tab)(() => ({
  textTransform: 'none',
}));

const StickyTabBox = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${colors.border.border_5p}`,
  backgroundColor: colors.background.main,
  marginTop: '24px',
  position: 'sticky',
  top: 0,
  zIndex: 1000,
}));

const CompetitionPageStyles = {
  paddingTop: '24px !important',
};

export { CustomTab, StickyTabBox, CompetitionPageStyles };
